<ng-template #template>
  @let col = column();
  @let colData = data();



  <td [class]="col.columnClass" [style]="style()">
    <span [pTooltip]="tooltipValue()" [tooltipDisabled]="!tooltipVisible()" [tooltipOptions]="{showDelay: 250}">
      @if(col.type === 'date') {
        {{colData[col.field] | date: col.dateFormat ?? 'MM/dd/yyyy'}}
      }

      @else if(col.type === 'phone') {
      <a [href]="'tel:' + colData[col.field]">{{colData[col.field]}}</a>
    }

    @else if(col.type === 'currency') {
    <div class="flex justify-end">{{colData[col.field] | currency: 'USD': 'symbol':'1.2-2'}}</div>
  }

  @else if(col.type === 'boolean') {
  {{colData[col.field] ? col.trueValue ?? 'Yes' : col.falseValue ?? 'No'}}
}

@else if(col.type === 'html') {
<div class="prose prose-sm dark:prose-invert" [innerHTML]="colData[col.field]"></div>
}
@else if(col.type === 'percentage') {
<div class="flex justify-end">{{formatPercentage(colData[col.field])}}%</div>
}

@else if (col.type === 'groupNameWithLink') {

@if (colData[col.custIdField]) {
  <a [href]="colData[col.custIdField] | contactCardUrl:colData[col.tripIdField ?? 'tripId']:col.fragment" target="_blank">
    @if (col.showCustId) {
      {{colData[col.custIdField]}} -
    }
    {{colData[col.field]}}
  </a>
}
@else{
@if (col.showCustId) {
  {{colData[col.custIdField]}} -
}
{{colData[col.field]}}
}


}

@else if (col.type === 'partnerNameWithLink') {
@if (colData[col.partnerIdField]) {
  <a [href]="colData[col.partnerIdField] | rootsUrlPipe" target="_blank">
    @if (col.showPartnerId) {
      {{colData[col.partnerIdField]}} -
    }
    {{colData[col.field]}}
  </a>
}
@else {
@if (col.showPartnerId) {
  {{colData[col.partnerIdField]}} -
}
{{colData[col.field]}}
}
}

@else if (col.type === 'logtype') {
<span>
  @switch (colData[col.field]) {
    @case (0) {
      <fa-icon [icon]="icons.solid.faDesktop" pTooltip="System" ></fa-icon>
    }
    @case (1) {
      <fa-icon [icon]="icons.solid.faFileText" pTooltip="Note" ></fa-icon>
    }
    @case (2) {
      <fa-icon [icon]="icons.regular.faEnvelope" pTooltip="Message" ></fa-icon>
    }
    @case (3) {
      <fa-icon [icon]="icons.solid.faEnvelope" pTooltip="Customer Service"
      ></fa-icon>
    }
    @case (4) {
      <fa-icon [icon]="icons.solid.faPhone" pTooltip="Call" ></fa-icon>
    }
    @case (5) {
      <fa-icon [icon]="icons.regular.faComments" pTooltip="Email or Text"
      ></fa-icon>
    }
    @case (6) {
      <fa-icon [icon]="icons.solid.faTasks" pTooltip="Task" ></fa-icon>
    }
    @case (7) {
      <fa-icon [icon]="icons.solid.faCoffee" pTooltip="In-person Meeting"
      ></fa-icon>
    }
    @default {
      <fa-icon [icon]="icons.solid.faCircleQuestion" pTooltip="Unknown"
      ></fa-icon>
    }
  }
</span>
}

@else if (col.type === 'chip') {
<div class="flex justify-center">
  @let data = colData[col.field];

  @if (isArray(data)) {
    @for (item of data; track $index) {
      @if (col.severityMap) {
        <p-tag [severity]="resolveTagSeverity(col?.severityMap![item])">{{item |
        titlecase}}</p-tag>
      }
      @else {
      <p-tag>{{item |
      titlecase}}</p-tag>
    }
  }
}
@else {
@if (col.severityMap) {
  <p-tag [severity]="resolveTagSeverity(col?.severityMap![colData[col.field]])">{{colData[col.field] |
  titlecase}}</p-tag>
}
@else {
<p-tag>{{colData[col.field] |
titlecase}}</p-tag>
}
}
</div>
}

@else if (col.type === 'number') {
<div class="flex justify-end">{{colData[col.field] | number: col.pipeParams ?? '1.0-0'}}</div>
}
@else if (col.type === 'link') {
@if(colData[col.linkField]) {
  <a [href]="colData[col.linkField]" [target]="col.target ?? '_blank'">{{col.staticText ?? colData[col.field]}}</a>
}
@else {
{{colData[col.field]}}
}
}
@else if (col.type === 'text' || col.type === 'string') {

{{colData[col.field]}}

}

@else {
{{colData[col.field]}}
}
</span>
</td>

</ng-template>